export default "__VITE_ASSET__BZ4itCzs__"